import { Breadcrumbs } from '@liveauctioneers/hammer-ui-core/breadcrumbs';
import { getSEOSearchPageBreadcrumbs } from '@/redux/modules/searchPromoted.selectors';
import { useAppSelector } from '@/redux/hooks';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
    className?: string;
};

export const SearchResultsBreadcrumbs = ({ className }: Props) => {
    const navigate = useNavigate();
    const breadcrumbs = useAppSelector(getSEOSearchPageBreadcrumbs);

    const onClick = useCallback(
        (href: string) => {
            navigate(href);
        },
        [navigate]
    );

    const breadcrumbsFormatted = useMemo(
        () =>
            breadcrumbs.map((breadcrumb) => ({
                href: breadcrumb.url,
                label: breadcrumb.name,
            })),
        [breadcrumbs]
    );

    if (breadcrumbs.length === 0) {
        return null;
    }

    return (
        <Breadcrumbs
            aria-label="Search Results Breadcrumbs"
            breadcrumbs={[{ href: '/', label: 'Home' }, ...breadcrumbsFormatted]}
            className={className}
            onClick={onClick}
        />
    );
};
